
import React, { useState, useEffect } from "react";
import Echart from "echarts-for-react";
import { getDate, getTime, getDay } from "components/common/dateTime";
import { useWindowSize } from "services/resizeservice";

export default function EnergyComponentsLine(props) {
  const [echartInstance, setEchartInstance] = useState(null);
  const size = useWindowSize();

  useEffect(() => {
    echartInstance?.resize();
  }, [size.width]);

  const { faultGraphData } = props;
  var xAxisData = [];
  var yAxisdData = [];
  var yAxisDataLabel = [];

  if (props?.faultGraphData != undefined) {
    props?.faultGraphData.map(function (obj) {
      if (
        props.selectTimeValue === "HOUR_24" ||
        props.selectTimeValue === "HOUR_12"
      ) {
        xAxisData.push(getTime(obj.endDate));
      } else if (props.selectTimeValue === "WEEK") {
        xAxisData.push(getDay(obj.endDate));
      } else {
        xAxisData.push(getDate(obj.endDate));
      }
      if (obj.faultCount === null || obj.faultCount === 0) {
        obj.faultCount = Math.round(Math.random() * 10);
        yAxisdData.push(obj.faultCount);
      } else {
        // yAxisdData.push(obj.yaxis);
        if (obj.yaxis != undefined) {
          yAxisDataLabel.push(obj.yaxis);
        }

        if (obj.yaxis != undefined) {
          yAxisdData.push(obj.yaxis === "0" ? "" : obj.yaxis);
        }

        if (obj.swapCount != undefined) {
          yAxisdData.push(obj.swapCount === "0" ? "" : obj.swapCount);
        }
      }
    });
  }

  var line = {
    tooltip: {
      trigger: "item",
    },
    xAxis: {
      type: "category",
      // data: [3, 6, 9, 12, 15, 18, 21, 24],
      data: xAxisData,
      name: "Time",
      nameLocation: "middle",
      nameGap: 30,
      nameTextStyle: {
        fontFamily: "JioType",
        fontStyle: "normal",
        fontWeight: 300,
        fontSize: "12",
        color: "#000000",
      },
    },
    yAxis: {
      type: "value",
      name: "No. of Faults",
      nameLocation: "middle",
      nameGap: 32,
      nameTextStyle: {
        fontFamily: "JioType",
        fontStyle: "normal",
        fontWeight: 300,
        fontSize: "12",
        color: "#000000",
      },
    },
    emphasis: {
      label: {
        show: true,
      },
    },
    grid: {
      left: "13%",
      right: "3%",
      bottom: "20%",
      top: 40,
      containLabel: true,
      show: true,
      width: "auto",
    },
    series: [
      {
        type: "line",
        color: "red",
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
        data: yAxisDataLabel,
      },
      {
        type: "line",
        //color: "red",
        // showBackground: true,
        // backgroundStyle: {
        //   color: "transparent",
        // },
        label: {
          show: true,
          position: "top",
        },
        symbol: 'circle',
        symbolSize: 10,
        color: "#E3324C",
        data: yAxisdData,
      },
      // {
      //   // data: [20, 55, 40, 75, 58, 65, 48],
      //   data: yAxisdData,
      //   type: "line",
      //   color: "red",
      //   label: {
      //     show: true,
      //     position: "top",
      //   },
      //   emphasis: {
      //     itemStyle: {
      //       shadowBlur: 10,
      //       shadowOffsetX: 0,
      //       shadowColor: "rgba(0, 0, 0, 0.5)",
      //     },
      //   },
      // },
    ],
  };
  return (
    // <div>
    <Echart
      styles={{ with: "100%", height: "80%" }}
      option={line}
      onChartReady={(instance) => {
        setEchartInstance(instance);
      }}
    ></Echart>
    // </div>
  );
}
